import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As the Chief Information Officer at Banque Misr, you've played a crucial role in
                implementing strategic initiatives. Could you share insights into some of the key IT
                initiatives that have contributed to Banque Misr's success, particularly in adapting
                to the evolving landscape of the banking industry?
              </strong>
            </h5>

            <h5 className="text-white">
              Banque Misr has always been pioneer in digital channels and applications. During 2024
              and Q1 2025, multiple initiatives have taken place that contributed in the bank’s
              success. Multiple mega-projects are under implementation/delivered that evolves the
              business services of the bank including.
              <ul>
                <li>
                  Core Banking Transformation where the IT is reviewing all the legacy
                  customizations with the business to unlock the true power of the system, product
                  rationalization, and business process re-engineering to streamline E2E business
                  service.
                </li>
                <li>
                  First Bank to implement Apple Pay and embed the feature in all delivery channels
                </li>
                <li>
                  Enhanced E2E Observability that monitors Network Performance, Infrastructure,
                  Application Performance and log file parsing and correlation
                </li>
                <li>
                  Adopt ITIL Framework and implement mature Change, incident, problem Management
                </li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Digital transformation is a buzzword in the financial industry. How has Banque
                Misr approached digital transformation under your leadership, and what specific
                technologies or strategies have proven most impactful in enhancing customer
                experience and operational efficiency?
              </strong>
            </h5>
            <h5 className="text-white">
              The strategy is to digitize all channels. This includes branches operations. Workflows
              have been developed to digitize processes such as the customer onboarding, loan
              origination and updating KYC. Processes that cannot be automated, RPA was used to
              streamline the process and use resources more efficient in other tasks. This is in
              addition to add more services to the different delivery channels such as Mobile
              Banking, Corporate Platform, integrating international remittances with the local
              InstaPay for instant transfers, etc. To achieve this, multiple technologies have been
              used including Enterprise Workflow Management systems, Content Management Systems, CRM
              for a single customer service scree and integration with all backend systems, scalable
              middlewareetc.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Managing high-performing IT teams is a significant aspect of your role. What
                leadership principles do you consider essential in fostering innovation and
                collaboration within your teams, especially in the dynamic and fast-paced
                environment of banking technology?
              </strong>
            </h5>
            <h5 className="text-white">
              Working with high-performing IT team is challenging especially when it comes to scale
              and managing 700+ team members. To embrace innovation, IT leadership agree on the
              focus areas of every year and the high-level end-state required. Empowering IT heads
              and delegating tasks increases the ownership of the team to the different initiatives.
              This is governed by Enterprise Architecture to ensure that all teams are moving in the
              same direction. In complex situations, and in crisis mode, I lead by example to set
              the correct process and ensure that all teams are aligneåd. Creating townhalls and
              newsletters propagates the different messages we need to cascade across the board and
              to the different job levels and ensure that the 700+ team members are aligned on the
              same strategic initiatives.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your profile mentions your proficiency in effectively communicating technical
                concepts to diverse audiences. In the context of the banking industry, how do you
                ensure clear communication between the IT department and other business units, and
                what role does effective communication play in the success of IT projects?
              </strong>
            </h5>
            <h5 className="text-white">
              <ul>
                <li>
                  Simplifying the technical discussion into simple logical terms that can be
                  understood by the business
                </li>
                <li>Prioritizing IT initiatives based on business values and Value-at-stake</li>
                <li>
                  Create a common ground where technical solutions are the key to achieve the
                  business values with less cost & enhanced efficiency
                </li>
                <li>
                  Regular ongoing meetings between IT & business to emphasize alignment and
                  understanding between all teams
                </li>
                <li>
                  Created IT Steering Committee, with the CIO as the chair, and committee members
                  are business, operations and different control functions to explain the IT
                  roadmap, challenges and align on the business objectives and goals.
                </li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Your active participation in industry events and forums reflects a commitment to
                knowledge sharing. Could you highlight some key insights or trends you've gained
                from these interactions, and how has staying engaged with the broader IT community
                influenced your approach to IT leadership at Banque Misr?
              </strong>
            </h5>
            <h5 className="text-white">
              The interactions with the different leaders in the community has evolved many of the
              initiatives that was started in Banque Misr. One initiative is the importance of
              Observability and the difference between monitoring and observability. This has
              enhanced the strategy and the internal directions. Recently, we started giving
              business teams dashboards that show insights on the performance of the different
              digital business services and KPIs.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Your active participation in industry events highlights your commitment to
                knowledge sharing and professional development. How important is collaboration
                between banks, technology providers, and regulatory bodies in driving innovation in
                the financial services sector?
              </strong>
            </h5>
            <h5 className="text-white">
              Collaboration between them is crucial for driving innovation. The 3 sectors complement
              each other and combining their strengths together, pave the road to provide digital
              financial compliant secure ecosystem that serve the customer without jeopardizing
              neither his privacy nor compliance.
              <br />
              <br />I have been appointed as the Head of the Technology Committee at Federation of
              Egyptian Banks, where all banking CIOs are members of this committee including
              regulatory bodies (when needed). This committee aims to discuss all the technology
              challenges that banks are facing for different reasons. In this committee we bridge
              the gap between the business, technology and the regulatory entities to find solutions
              and roadmaps.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- The future of banking is rapidly evolving, with technology at its core.What is
                your vision for the future of banking in North Africa, and what role will technology
                play in shaping that future?
              </strong>
            </h5>
            <h5 className="text-white">
              <ul>
                <li>
                  Significant transformation driven by technological advancements & evolving
                  customer demands
                </li>
                <li>
                  Increased investment in digital infrastructure to enhance connectivity &
                  accessibility
                </li>
                <li>Leap shift towards digital banking experience</li>
                <li>More focus on customer experience (Customer Centric)</li>
                <li>Rise of Fintechs</li>
                <li>Collaboration between banks & fintechs to provide seamless fintech services</li>
                <li>
                  Change in regulatory frameworks to cater for technological advancement &
                  innovation promotion
                </li>
                <li>Financial inclusion</li>
                <li>Strengthening cross border collaboration</li>
                <li>
                  AI and gen-AI will play a big role in the banking sector to minimize fraud, risk,
                  and maximized profitability.
                </li>
                <li>
                  Data driven decisions will be the core of any product build and giving customers
                  personalized experience.
                </li>
              </ul>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You will be speaking at Finnovex North Africa on April 23rd. What key message or
                takeaway would you like the audience to leave with from your session, especially
                regarding the role of technology in shaping the future of banking in the region?
              </strong>
            </h5>
            <h5 className="text-white">
              Shaping the future starts from today’s activity. How can we be prepared for all the
              new technological trends and have a strong architectural foundation that can support
              the future business needs. This requires good planning and strategy that covers the
              infrastructure, observability, security, applications integrations, middleware and API
              gateways, open banking architecture, and the different delivery models (Agile /
              waterfall / hybrid) and operating models of the IT (tribes, departmental).
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
